module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/confirmation-page/confirmation-page.component.scss
// module id = ./src/app/shared/components/confirmation-page/confirmation-page.component.scss
// module chunks = main